module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_5012.503bf862.png";